import { render, staticRenderFns } from "./HelpCentre.vue?vue&type=template&id=4ff312f0&"
import script from "./HelpCentre.vue?vue&type=script&lang=js&"
export * from "./HelpCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports